var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategories11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_26833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.8125C5 1.60438 4.02062 0.625 2.8125 0.625C1.60438 0.625 0.625 1.60438 0.625 2.8125C0.625 4.02062 1.60438 5 2.8125 5C4.02062 5 5 4.02062 5 2.8125Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 10C5 8.79188 4.02062 7.8125 2.8125 7.8125C1.60438 7.8125 0.625 8.79188 0.625 10C0.625 11.2081 1.60438 12.1875 2.8125 12.1875C4.02062 12.1875 5 11.2081 5 10Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17.1875C5 15.9794 4.02062 15 2.8125 15C1.60438 15 0.625 15.9794 0.625 17.1875C0.625 18.3956 1.60438 19.375 2.8125 19.375C4.02062 19.375 5 18.3956 5 17.1875Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 2.8125C12.1875 1.60438 11.2081 0.625 10 0.625C8.79188 0.625 7.8125 1.60438 7.8125 2.8125C7.8125 4.02062 8.79188 5 10 5C11.2081 5 12.1875 4.02062 12.1875 2.8125Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 10C12.1875 8.79188 11.2081 7.8125 10 7.8125C8.79188 7.8125 7.8125 8.79188 7.8125 10C7.8125 11.2081 8.79188 12.1875 10 12.1875C11.2081 12.1875 12.1875 11.2081 12.1875 10Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 17.1875C12.1875 15.9794 11.2081 15 10 15C8.79188 15 7.8125 15.9794 7.8125 17.1875C7.8125 18.3956 8.79188 19.375 10 19.375C11.2081 19.375 12.1875 18.3956 12.1875 17.1875Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 2.8125C19.375 1.60438 18.3956 0.625 17.1875 0.625C15.9794 0.625 15 1.60438 15 2.8125C15 4.02062 15.9794 5 17.1875 5C18.3956 5 19.375 4.02062 19.375 2.8125Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 10C19.375 8.79188 18.3956 7.8125 17.1875 7.8125C15.9794 7.8125 15 8.79188 15 10C15 11.2081 15.9794 12.1875 17.1875 12.1875C18.3956 12.1875 19.375 11.2081 19.375 10Z",
    fill: "#D42124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.375 17.1875C19.375 15.9794 18.3956 15 17.1875 15C15.9794 15 15 15.9794 15 17.1875C15 18.3956 15.9794 19.375 17.1875 19.375C18.3956 19.375 19.375 18.3956 19.375 17.1875Z",
    fill: "#D42124"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_26833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories11);
export default __webpack_public_path__ + "static/media/categories(1)1.1989ca6d65598dffa34d8dde66bddeb0.svg";
export { ForwardRef as ReactComponent };